export enum QueryKey {
  Authentication = "Authentication",
  Tenant = "Tenant",
  Role = "Role",
  Person = "Person",
  GoogleCloudStorage = "GoogleCloudStorage",
  TransportType = "TransportType",
  UtilTransportLocation = "UtilTransportLocation",
  UtilActivityType = "UtilActivityType",
  Location = "Location",
  Client = "Client",
  Agent = "Agent",
  Hotel = "Hotel",
  RoomType = "RoomType",
  Activity = "Activity",
  Package = "Package",
  Quotation = "Quotation",
  RatePerPax = "RatePerPax",
  PackageActivity = "PackageActivity",
  QuoteActivity = "QuoteActivity",
  QuoteTransport = "QuoteTransport",
  QuoteAccommodation = "QuoteAccommodation",
  Invoice = "Invoice",
  TravelVoucher = "TravelVoucher",
  Payment = "Payment",
  PackageTransport = "PackageTransport",
  PackageAccommodation = "PackageAccommodation",
  Status = "Status",
  UtilAgeBracket = "UtilAgeBracket",
  Dashboard = "Dashboard",
  // KEY ADD
}
